export const TranslationsPL = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
    },
    // BASE
    phrases: {
        order_online: 'Zamów online',
        cart: 'Wózek',
        open_24: '24 godziny',
        closed: 'Zamknięte',
        free: 'DARMOWE',
        something_went_wrong: 'coś poszło nie tak',
        try_again: 'bądź ponownie',
    },
    constants: {
        calendar: {
            days: {
                monday: 'Poniedziałek',
                tuesday: 'Wtorek',
                wednesday: 'Środa',
                thursday: 'Czwartek',
                friday: 'Piątek',
                saturday: 'Sobota',
                sunday: 'Niedziela',
            },
        },
        services: {
            pickup: 'Ulec poprawy',
            delivery: 'Dostawa',
            dine_in: 'Zjedz obiad',
            table_booking: 'Rezerwacja stolika',
        },
        payment: {
            method: {
                cash: 'Gotówka',
                card: 'Karta',
                stripe: 'Karta kredytowa',
                paypal: 'PayPal',
                cardconnect: 'Karta kredytowa',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Gotówka',
                card: 'Karta',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: 'Sukces',
                pending: 'Aż tak',
                error: 'Błąd',
                refunded: 'Zwrócono pieniądze',
                refunding: 'Zwrot pieniędzy',
                partial_refunded: 'Częściowo zwrócony',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Usunąć',
                drop_here: 'Użyj plików tutaj lub kliknij, aby wybrać jeden',
                accepts: 'Akceptuje pliki {{fileTypes}}',
                errors: {
                    max_files: 'Dozwolone maksymalnie {{number}}',
                    max_size: 'Maksymalny rozmiar pliku {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'Sklep jest obecnie zamknięty i nie można złożyć zamówienia na miejscu na teraz. Spróbuj zamiast tego zamówić na późniejszą datę i godzinę',
            },
            buttons: {
                order: {
                    book_order: 'zarezerwowany stolik / zamów online',
                    order_online: 'Zamów online',
                    book_table: 'Należy zarezerwować stolik',
                    order: 'Zamówienie',
                    book: 'Książka',
                    cart: 'Wózek',
                    restart: 'Uruchom ponownie',
                    closed: 'Sklep zamknięty',
                    not_accepting: 'Nieprzyzwyczajony do noszenia',
                },
            },
        },
        modals: {
            auth: {
                login: 'Zaloguj się',
                register: 'Rejestr',
                register_commence: 'Kontynuować',
                register_complete: 'Utwórz konto',
                register_confirmation_sent: 'Kod potwierdzający został wysłany na Twój adres e-mail. Wpisz go poniżej, aby kontynuować',
                register_confirmation_resent: 'Kod potwierdzający został wysłany ponownie, sprawdź folder spam lub rozpocznij proces od nowa',
                register_restart: 'Uruchom ponownie',
                register_resend_code: 'Wyślij kod ponownie',
                register_confirmation_code_subject: 'Kod utrzymujący e-mail',
                register_confirmation_code_email: 'Twój kod użytkowy wyślij e-mail na adres {{confirmation_code}} (wygasa za 24 godziny)',
                login_placeholder: 'Adres e-mail',
                password_placeholder: 'Hasło',
                confirm_password_placeholder: 'Potwierdź hasło',
                confirmation_code_placeholder: 'Kod utrzymujący e-mail',
                accept_terms: 'Zaakceptuj Regulamin',
                accept_terms_view: 'Pogląd',
                login_facebook: 'Zaloguj się za pomocą Facebooka',
                login_google: 'Zaloguj się za pomocą Google',
                benefits: 'Zaloguj się lub utwórz konto, aby zapisać wszystkie swoje zamówienia',
                logged_in: 'Zalogowano pomyślnie',
                logged_out: 'Wylogowano',
                password_reset: {
                    init_button: 'Wyślij wiadomość dotyczącą resetowania hasła',
                    init_success: 'Link do resetowania hasła został wysłany na Twój e-mail',
                    complete_button: 'Zresetuj hasło',
                    complete_success: 'Hasło zostało pomyślnie zresetowane, zaloguj się przy użyciu nowego hasła',
                    forgot_password_text: 'Zapomniałeś hasła?',
                    forgot_password_link: 'Zresetuj hasło',
                    remember_password_text: 'Pamiętasz swoje hasło?',
                    remember_password_link: 'Wracając',
                    invalid_title: 'Resetowanie hasła bezpieczeństwa',
                    invalid_description: 'Dziesięć linków do resetowania hasła jest ustalane. Zamiast tego poproś o nowy',
                    invalid_link: 'Przejdź do logowania',
                    title: 'Resetowanie hasła',
                    description: 'Wprowadź nowe hasło do swojego konta',
                },
                error_generic: 'Coś poszło nie tak. Najpierw ponownie lub zainstaluj się z nami',
                error_accept_terms: 'Proszę zaakceptować regulamin',
                error_password_length: 'Hasło minimum 6 znaków',
                error_social: 'Coś poszło nie tak. Najpierw ponownie lub zainstaluj się z nami',
                error_confirmation_code: 'Nieprawidłowy kod możliwycy',
                error_invalid_code: 'Nieprawidłowy kod możliwycy',
                error_exists: 'Użytkownik już istnieje',
                error_invalid_email_pass: 'Nieprawidłowy adres e-mail lub hasło',
                error_password_no_match: 'Hasła nie została usunięta do siebie',
                error_user_not_found: 'Brak użytkownika o tym adresie e-mail',
                error_invalid_email: 'Nieprawidłowy adres e-mail',
                error_invalid_reset_token: 'Nieprawidłowy link resetowania. Poproś o inny',
            },
            booking: {
                form: {
                    name: 'Pełne imię i nazwisko',
                    email: 'Adres e-mail',
                    phone: 'Numer telefonu',
                    number_of_people: 'Liczba Osób',
                    number_of_people_max: 'Liczba osób (maks. {{max_people}})',
                    number_of_people_min: 'Liczba osób ({{min_people}} min)',
                    number_of_people_max_min: 'Liczba osób (od {{min_people}} do {{max_people}})',
                    notes: 'Uwagi/Żądania specjalne',
                    submit: 'Prześlij prośbę o rezerwację',
                    email_optional: '(opcjonalnie)',
                    date: 'Data',
                    duration: 'Czas trwania',
                    seating: 'Dostępne godziny',
                    number_of_guests: 'Liczba gości',
                    notes_placeholder: 'Alergie, okazja, preferowane miejsce',
                    reserving: 'Rezerwowanie...',
                    reserve_table: 'Zarezerwuj stolik',
                    please_choose_a_date_and_time: 'Wybierz datę i godzinę.',
                    invalid_people: 'Liczba osób musi mieścić się między {{min}} a {{max}}.',
                    party_size_max_fallback: 'dozwolone maksimum',
                    loading_available_times: 'Ładowanie dostępnych godzin…',
                    select_a_date_to_see_available_times: 'Wybierz datę, aby zobaczyć dostępne godziny.',
                    no_times_available_for_this_date: 'Brak dostępnych godzin w tym dniu. Wybierz inny dzień.',
                    shift: 'Zmiana',
                    service_times: 'Godziny obsługi',
                    new_shift: 'Nowa zmiana',
                    time: 'godzina',
                    times: 'godziny',
                    unavailable: 'Niedostępne',
                    available: 'Dostępne',
                    required_name: 'Podaj swoje imię i nazwisko.',
                    required_phone: 'Podaj swój numer telefonu.',
                    required_email: 'Podaj swój adres e-mail.',
                    invalid_email: 'Podaj prawidłowy adres e-mail.',
                    required_terms: 'Zaakceptuj regulamin przed dokonaniem rezerwacji.',
                    reservation_is_unavailable: 'Rezerwacja jest niedostępna.',
                    please_contact_the_restaurant_directly: 'Skontaktuj się bezpośrednio z restauracją.',
                    almost_done: 'Prawie gotowe',
                    your_details: 'Twoje dane',
                    tell_us_who_s_coming: 'Powiedz nam, kto przyjdzie, abyśmy mogli potwierdzić rezerwację.',
                    book_your_table: 'Zarezerwuj stolik',
                    choose_a_time_that_works_for_you: 'Wybierz godzinę, która Ci odpowiada.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Wyślij prośbę o rezerwację, a restauracja zajmie się resztą.',
                    select_date: 'Wybierz datę',
                    standard: 'Standard',
                    minutes: 'minut',
                    next: 'Dalej →',
                    back: '← Wstecz',
                    accept_terms: 'Akceptuję regulamin.',
                    info_1: 'otrzymanie powiadomienia e-mailem o przyjęciu lub odrzuceniu rezerwacji',
                },
                errors: {
                    not_found: 'Rezerwacja nie istnieje. Trzeba było zostać usunięte',
                    generic: 'Coś poszło nie tak, aktualizacja karty lub powstała z nami',
                    something_went_wrong: 'Coś poszło nie tak',
                    accept_terms: 'Proszę zaakceptować regulamin',
                    required_phone: 'Proszę podać swój numer telefonu',
                    required_email: 'Proszę podać swój adres e-mail',
                    required_zip: 'Proszę o wprowadzenie rozliczeniowego kodu pocztowego',
                    required_name: 'Proszę wpisać swoje imię i nazwisko',
                    invalid_email: 'Proszę o poprawny adres e-mail',
                    invalid_phone: 'Proszę wprowadzić numer telefonu',
                    invalid_people: 'Nieprawidłowa liczba osób',
                    missing_custom_fields: 'Proszę wypełnić wszystkie wymagane pola.',
                    booking_capacity_threshold: 'Na tę godzinę nie mamy wolnych miejsc. Wybierz inny termin.',
                    slot_unavailable: 'Na tę liczbę osób nie mamy wolnych miejsc. Wybierz inny termin.',
                    booking_date_paused: 'Rezerwacje na ten dzień są wstrzymane. Wybierz inny dzień.',
                    invalid_table_assignment: 'Te stoliki nie pomieszczą Twojej grupy. Wybierz inną godzinę.',
                    exceeded_order_limit: 'Zbyt wiele próśb o rezerwację. Spróbuj ponownie później.',
                    validation_failed_recaptcha_v3: 'Wykryto nietypowy ruch. Czy używasz VPN? Rozwiąż zadanie powyżej i spróbuj ponownie.',
                    validation_failed_recaptcha_v2: 'Nie udało się rozpocząć rezerwacji. Spróbuj ponownie lub użyj innej metody. Jeśli używasz VPN, wyłącz go najpierw.',
                    booking_already_exists: 'Ta rezerwacja została już wysłana. Sprawdź e-mail lub otwórz link do rezerwacji.',
                    invalid_party_size: 'Wybierz prawidłową liczbę osób.',
                    invalid_request: 'Nieprawidłowe żądanie. Odśwież stronę i spróbuj ponownie.',
                    table_booking_unavailable: 'Rezerwacja stolików jest niedostępna.',
                },
            },
            cart: {
                title: 'Wózek',
                proceed_to_checkout: 'Przejdź do kasy',
                edit_dish: 'Redagować',
                remove_dish: 'Usunąć',
                no_items_1: 'Brak produktów w koszyku',
                no_items_2: 'Dodaj trochę, aby kontynuować',
                free_delivery_notice: 'Bezpłatna dostawa dla czyszczenia powyżej {{value, currency}}',
                errors: {
                    min_order_promo: 'Minimalna wartość koszyka {{value, currency}} wymagana przed zastosowaniem tej promocji',
                    min_order_delivery: 'Minimalna wartość koszyka {{value, currency}} do dostawy',
                },
                promo: {
                    heading: 'Kod promocyjny',
                    placeholder: 'Wpisz swój kod promocyjny',
                    add: 'Dodaj kod',
                    title: 'Promocja {{name}} dodana do koszyka',
                    fixed_discount: '{{value, currency}} Wyłączny',
                    percent_discount: '{{value}}% używane',
                    added_to_cart: 'Promocja dodana do koszyka',
                    errors: {
                        not_found: 'Nie znaleziono promocji',
                        disabled: 'Promocja jest wyłączona',
                        not_available: 'Promocja jest obecnie niedostępna',
                        not_eligible: 'Nie kwalifikuje się do zastosowania kodu promocyjnego',
                        not_available_time: 'Promocja nie dotyczy tego czasu',
                        logged_in_only: 'Aby móc korzystać z tej promocji, musisz się upewnić',
                        already_used: 'Skorzystałeś już z tej promocji',
                        invalid: 'Ta promocja jest już nieaktualna',
                        invalid_service: 'Ta promocja nie dotyczy odbioru przez Ciebie usług',
                        later_only: 'Dotyczy wyłącznie w przedsprzedaży',
                        now_only: 'Dotyczy wyłącznie środków czystości, a nie czyszczenia przed sprzedażą',
                        generic: 'Ups... coś poszło nie tak i odpadło',
                        dishes_required_multi: 'Ta promocja będzie stosowana tylko wtedy, gdy dodane zostaną określone produkty',
                        dishes_required_single: "Ta promocja zostanie zastosowana tylko dla '{{dish}}'",
                    },
                },
                tip: {
                    title: 'Omówienie zamówienia',
                    placeholder: 'Dodaj wskazówkę dotyczącą zamówienia',
                },
            },
            free_items_promo: {
                title: 'Bezpłatne przedmioty',
                usage_confirmation: {
                    question: 'Masz prawo do bezpłatnych bezpłatnych usług. Możesz je dodać i dodać?',
                    cancellation: 'Nie, nie chcę bezpłatnych pozycji',
                    acceptance: 'Tak',
                },
                free_items_selection: {
                    multiple: {
                        description: 'Wybierz {{number}} bezpłatne elementy',
                    },
                    single: {
                        description: 'Wybierz darmowy przedmiot',
                    },
                    confirm_button: 'naprawić',
                },
            },
            checkout: {
                title: 'Finalizacja zamówienia',
                subtitle: 'Potwierdź szczegóły zamówienia',
                details: {
                    service: 'Praca',
                    due: 'niezależny',
                    due_now_asap: 'Teraz / JAK NAJSZYBCIEJ',
                    address: 'Adres dostawy',
                    total: 'Całkowity',
                    table: 'Tabela',
                    store_location: 'Adres sklepu',
                },
                customer: {
                    title: 'Klient',
                    subtitle: 'Zaloguj się, aby zapisać swoje zamówienie i szczegóły',
                    button: 'Zaloguj się',
                    name: 'Pełne imię i nazwisko',
                    email: 'E-mail',
                    phone: 'Telefon',
                    phone_important: 'Telefon (ważne)',
                    notes: 'Uwagi do zamówienia',
                    delivery_notes: 'Instrukcje dostawy / uwagi do zamówień',
                    optional: 'fakultatywny',
                },
                payment: {
                    title: 'Metoda płatności',
                    qr_modal_help: 'Użyj aplikacji mobilnej {{app}}, aby zeskanować kod QR i dokończyć płatność za to zamówienie. Gdy płatność zostanie ukończona w aplikacji mobilnej, możesz zamknąć to okno QR. Nie zamykaj tego okna QR, jeśli nie zakończyłeś procesu płatności.',
                    switch_to_app_help: 'Po naciśnięciu przycisku poniżej aplikacja mobilna {{app}} zostanie otwarta automatycznie, aby dokończyć płatność za to zamówienie. Gdy płatność zostanie ukończona w aplikacji mobilnej, możesz zamknąć to okno. Nie zamykaj tego okna, jeśli nie zakończyłeś procesu płatności.',
                    open_app: 'Otwórz aplikację {{app}}',
                    continue: 'Kontynuować',
                    continue_to_payment: 'Kontynuuj do {{method}}',
                    back_to_cart: 'Powrót do koszyka',
                },
                accept_terms: 'Zaakceptuj Regulamin',
                accept_terms_view: 'Pogląd',
                processing_order: 'Zamówienie przetwarzania',
                warning: {
                    different_payment_currency: 'Ceny w sklepie są w walucie {{store_currency}}, ale metoda płatności jest w walucie {{payment_currency}}',
                    closing_soon: 'Zamknięcie wkrótce. Zamówienia należy składać w ciągu {{value}} minut',
                    closed: 'Przepraszamy, ta usługa została anulowana i zamówienia są nieakceptowalne',
                    paused: 'Usługa została przygotowana w tej chwili, gdy zamówienia nie są akceptowane',
                    expired: 'Nie możesz już korzystać z zamówień, które wybierzesz przez Ciebie. Proszę wybrać późniejszy termin lub godzinę',
                },
                errors: {
                    walletly_promo: 'Portfel Promocja zawiera błąd. dostęp do innej promocji!',
                    stripe_generic: 'Błąd karty pamięci. Następny lub inna metoda',
                    validation_failed: 'Ta płatność może nie zostać zaakceptowana. Następny później lub wybierz opcję płatności.',
                    validation_failed_recaptcha_v3: 'Wykryto inny ruch. Czy korzystasz z VPN? Ukończ zadanie i ponownie je odzyskaj.',
                    validation_failed_recaptcha_v2: 'Nie można zastosować płatności. metody alternatywne lub inne metody. Jeśli skorzystasz z VPN, najpierw przejdź do.',
                    stripe_loading_fail: 'Błąd podczas ładowania płatności. najpierw ponownie',
                    something_went_wrong: 'Coś poszło nie tak',
                    paypal_generic: 'Coś poszło nie tak z PayPalem. Następny lub wybierz opcję płatności',
                    payment_fail: 'Płatność nie powiodła się. Następny lub wybierz opcję płatności',
                    payment_cancelled: 'Płatność anulowana. Następny lub wybierz opcję płatności',
                    payment_error: 'Błąd podczas przetwarzania płatności online. Następny lub wybierz opcję płatności',
                    payment_declined: 'Twoja metoda płatności została odrzucona',
                    card_declined: 'Twoja karta została odrzucona i nie udało się przetworzyć płatności',
                    promo_max_uses_exceeded: "Ten kod promocyjny osiągnął limit użyć i nie jest już dostępny.",
                    store_closed: 'Sklep jest zamknięty i nie został już przyjęty',
                    accept_terms: 'Proszę zaakceptować regulamin',
                    required_payment: 'Wybierz formę płatności',
                    required_phone: 'Proszę podać swój numer telefonu',
                    required_email: 'Proszę podać swój adres e-mail',
                    required_zip: 'Proszę o wprowadzenie rozliczeniowego kodu pocztowego',
                    required_name: 'Proszę wpisać swoje imię i nazwisko',
                    invalid_email: 'Proszę o poprawny adres e-mail',
                    invalid_phone: 'Proszę wprowadzić numer telefonu',
                    invalid_cc_number: 'Numer karty kredytowej jest zainstalowany',
                    invalid_order_amount: 'Minimalna kwota wymagana dla tej metody płatności',
                    retry_cc_number: 'Coś poszło nie tak. Wprowadź ponownie numer swojej karty, aby uzyskać jeszcze raz',
                    closed: 'Sklep jest zamknięty i nie zaakceptowany',
                    promo_login_required: 'Aby móc korzystać z tej promocji, musisz się upewnić',
                    promo_used: 'Skorzystałeś już z tej promocji',
                    promo_by_payment_method_not_applicable: 'Promocja nie dotyczy metod płatności.',
                    missing_custom_checkout_fields: 'Proszę wypełnić wszystkie wymagane pola.',
                    delivery_unavailable: 'Usługa dostawy może być teraz niedostępna. Rozważ zamiast tego zamówienie z odbiorem osobistym.',
                    required_delivery_provider: 'Proszę wybrać sposób udostępniania usług.',
                    required_delivery_quotation: 'Szacowana dostawa wysłana.',
                    exceeded_order_limit: 'W tej chwili otrzymujemy dużo ładunku. Proszę wybrać późniejszy termin.',
                    exceeded_order_limit_later: 'Nie możesz już korzystać z zamówień, które wybierzesz przez Ciebie. Proszę wybrać późniejszy termin lub godzinę',
                },
                button: {
                    continue: 'Kontynuuj płatność',
                    place_order: 'Dodaj zamówienie',
                    update_order: 'Aktualizuj zamówienie',
                },
                delivery_estimation: {
                    title: 'Szacowanie dostawy',
                    details: {
                        provider: 'Dostępność dostawy',
                        estimated_fee: 'Szacowana opłata',
                        estimated_total_fee: 'Całkowita opłata za dostawę',
                        estimated_discount_fee: 'Zniżka na opłatę za dostawę',
                        previous_estimated_fee: 'Poprzednia szacunkowa opłata',
                        tips: 'Porady',
                        estimated_delivery_time: 'Szacowany czas dostawy',
                        uber_new_estimation: 'Poproś o nową wycenę',
                        uber_new_estimation_success: 'Zastosowano nowy szacunkowy koszt dostawy Uber.',
                        uber_estimation_expired: 'Szacowana dostawa wysłana',
                        uber_price: 'Utrzymujemy cenę Ubera',
                        uber_need_time: 'Potrzebuję więcej czasu',
                        lalamove_price: 'Wstrzymaliśmy opłatę za dostawę Lalamove',
                        lalamove_new_estimation_success: 'Zastosowano nową szacunkową dostawę Lalalmove.',
                        lalamove_estimation_expired: 'Szacowana dostawa wysłana',
                        lalamove_need_time: 'Potrzebuję więcej czasu',
                        lalamove_new_estimation: 'Poproś o nową wycenę',
                    },
                    quotation_error: 'Coś poszło nie tak przy obliczaniu przewidywanej dostawy.',
                },
            },
            customer: {
                age_v: {
                    title: 'Weryfikacja wieku',
                    required_for_items: 'Wymagane do zamówienia niektórych pozycji',
                    min_age: 'Minimalny wiek: {{age}} łac',
                    est_time: 'Szacowany czas weryfikacji: {{time}} godzin',
                    upload_description: 'Prześlij poniżej dokument tożsamości do weryfikacji. O wyniku weryfikacji poinformujemy Cię e-mailem. Możesz przesłać maksymalnie 2 obrazy, każdy o rozmiarze do 2 MB',
                    pending_description_1: 'Dziękujemy za przesłanie dokumentów. Poinformujemy Cię e-mailem, gdy zostaniesz zatwierdzony',
                    pending_description_2: 'Odśwież stronę, aby zaktualizować status weryfikacji. Szacowany czas weryfikacji to {{time}} godzin',
                    approved_description: 'Twoje konto zweryfikowane i możesz sprawdzić zamówienia z zastrzeżonych menu',
                    rejected_description: 'Twój dowód tożsamości został odrzucony. Jeśli chcesz spróbować ponownie, prześlij ponownie swój identyfikator',
                    upload: 'Wgrywać',
                    reupload: 'Prześlij ponownie dokumenty',
                    go_back: 'Wracając',
                    view_document: 'Wyświetl dokument {{number}}',
                    status: {
                        unverified: 'Niesprawdzony',
                        pending: 'Oczekiwanie na zatwierdzenie',
                        approved: 'Pomyślnie zweryfikowano',
                        rejected: 'Odrzucić',
                    },
                },
                headings: {
                    sessions: 'Sesje',
                    orders: 'Zamówienie',
                    spend: 'Wyświadczyć',
                    order_history: 'Historia zniszczona',
                    loyalty: 'Lojalność',
                    loyalty_points: 'Punkty kontrolne',
                    added: 'Dodana promocja.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'Proszę wybrać dowolny przedmiot przed zastosowaniem!',
                    not_found: 'Nie znaleziono promocji!',
                    already_exists: 'Promocja już istnieje!',
                    try_again: 'Nie można tej oceny oferty. najpierw ponownie!',
                },
            },
            custom_payment: {
                title: '{{name}} Formularz płatności',
                description: 'Jesteś w naszym formularzu płatności online. Wypełnij poniższe pola, aby dokonać płatności. Jeśli kwota nie zostanie wpisana, Twoje dane zostaną zapisane, ale opłata nie zostanie pobrana.',
                disabled: 'Ta strona płatności online nie została poprawnie skonfigurowana. Skontaktuj się z właścicielem strony, aby rozwiązać ten problem.',
                success: 'Twoja płatność została pomyślnie przetworzona, a Twoje dane zostały otrzymane. Dziękuję',
                back: 'Powrót do domu',
                fields: {
                    name: 'Pełne imię i nazwisko',
                    email: 'Adres e-mail',
                    reference: 'Nr ref. płatność',
                    amount: 'Kwota ($)',
                    name_on_card: 'Imię i nazwisko na karcie',
                    submit: 'Prześlij płatność',
                },
                warning: {
                    currency: 'Uwaga: kwota płatności w {{actual}}, a nie {{default}}',
                },
                errors: {
                    generic: 'Coś poszło nie tak. Najpierw ponownie lub zainstaluj się z nami',
                    stripe_generic: 'Błąd karty pamięci. Odśwież stronę i ponownie',
                    payment_fail: 'Płatność nie powiodła się. Następny lub wybierz opcję płatności',
                    payment_cancelled: 'Płatność anulowana. Następny lub wybierz opcję płatności',
                    payment_error: 'Błąd podczas przetwarzania płatności online. Następny lub wybierz opcję płatności',
                    payment_declined: 'Twoja metoda płatności została odrzucona',
                    card_declined: 'Twoja karta została odrzucona i nie udało się przetworzyć płatności',
                    promo_max_uses_exceeded: "Ten kod promocyjny osiągnął limit użyć i nie jest już dostępny.",
                },
            },
            dish: {
                add: 'Dodaj do koszyka',
                edit: 'Aktualizuj element',
                notes: 'Specjalne instrukcje...',
                ingredients: {
                    title: 'Składniki',
                    uncheck_remove: 'Usuń zaznaczenie, aby usunąć',
                },
                ingredients_title: 'Składniki',
                combo: {
                    choose_dish: 'Wybierz przedmiot',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Wybierz jeden (wymagany)',
                        select_one_optional: 'Wybierz jeden (opcjonalnie)',
                        select_between: 'Wybierz pomiędzy {{min}} - {{max}} (wymagane)',
                        select_at_least: 'Wybierz co najmniejszy {{qty}} (wymagane)',
                        select_up_to: 'Wybierz opcję {{qty}} (opcjonalnie)',
                        select_multiple_optional: 'Wybierz wiele (opcjonalnie)',
                        select_multiple: 'Wybierz wiele (wymagane)',
                        free_amount: 'Pierwszy {{qty}} wolny / {{selected}} wybrany',
                    },
                    points: {
                        none_consumed: 'Możesz wybrać maksymalnie {{maxFree}} opcję za darmo',
                        less_than_total_points: 'Możesz wybrać więcej opcji za darmo',
                        greather_than_total_points: 'Możesz wybrać więcej opcji za dodatkową opłatą',
                    },
                },
                error: 'Popraw wszystkie opcje zaznaczone na czerwono',
                added_to_cart: 'Pozycja dodana do koszyka',
            },
            map: {
                zone_fee: 'Opłata za dostawę',
                view_in_google: 'Zobacz w Mapach Google',
            },
            portal_go_back: {
                title: 'Wrócić do wyszukiwania restauracji?',
                description: 'Wszelkie informacje w przewodniku pomocniczym',
                cancel: 'Anulować',
                proceed: 'Wracając',
            },
            order: {
                config: {
                    services: {
                        title: 'Wybierz usługę',
                        table_booking: 'Tabela książek',
                    },
                    address_custom: {
                        input_placeholder: 'Wpisz swój adres',
                    },
                    address: {
                        input_placeholder: 'Znajdź swój adres dostawy',
                        extras_placeholder: 'Numer jednostki, nazwa budynku, instrukcje dostawy itp.',
                        search_placeholder: 'Wyszukaj swój adres',
                        search_input_placeholder: 'Wpisz, aby wyszukać',
                        no_address_found: 'Nie znaleziono adresu. zawiera więcej niż 5 znaków',
                        not_found: 'Nie znaleziono adresu dostawy lub jest on niedostępny. najpierw ponownie',
                        not_delivering: 'Aktualnie nie dostarczamy pod ten adres',
                        not_in_range: 'Twój adres nie mieści się w lokalizacji naszego sklepu',
                        not_in_zone: 'Twój adres nie znajduje się w aktywnej strefie dostawy',
                        no_number: 'Twój adres musi zawierać numer ulicy',
                        location_permission: 'Zezwolić tej witryny na dostęp do bieżącej lokalizacji?',
                        location_permission_warning: 'Nie można uzyskać dostępu do Twojej bieżącej lokalizacji. Włącz usługę lokalizacji na urządzeniu i w przeglądarce. Oto kilka wskazówek:',
                        pick_location: 'Wybierz swoją lokalizację',
                        pick_location_help_text: 'Przeciągnij znacznik, aby wybrać lokalizację na mapie.',
                        use_current_location: 'bezpośredniej lokalizacji',
                        locate_on_map: 'Zlokalizuj na mapie',
                    },
                    datetime: {
                        title: 'Kiedy chcesz otrzymać zamówienie',
                        due_now: 'Teraz',
                        due_later: 'Później',
                        service_not_available: 'Przepraszamy, obecnie nie przyjmujemy na {{service}}',
                        currently_closed: '{{service}} obecnie zamknięte, ale możesz złożyć zamówienie na później',
                        due_unavailable: 'Nie płynny',
                        due_closed: 'Zamknięte',
                        select_date: 'Wybierz opcję Dane',
                        select_time: 'Wybierz Czas',
                        select_order_date: 'Wybierz datę zamówienia',
                        select_order_time: 'Wybierz czas zamówienia',
                        select_order_date_time: 'data Wybierz/godzinę zamówienia',
                        select_booking_date: 'data rezerwacji',
                        select_booking_time: 'Wybierz godzinę rezerwacji',
                        no_times_available: 'Brak zakończenia terminów do wyboru',
                        date_today: '(Dzisiaj)',
                        date_closed: '(Zamknięte)',
                        date_bookings_paused: '(Rezerwacje wstrzymane)',
                        time_slot_closed: 'Zamknięte',
                    },
                    number_of_people: {
                        placeholder: 'Liczba Osób',
                    },
                    table: {
                        select: 'Wybierz opcję Tabela',
                        select_popup_title: 'Wybierz swoje krzesło',
                        password: 'Hasło tabeli',
                        password_warning: 'Wprowadź hasło do swojego stołu, aby móc je kontynuować',
                    },
                    warning: {
                        closed: 'Przepraszamy, jesteśmy obecnie zamknięci / nie przyjmujemy żadnych uwag',
                        not_available: 'Przepraszamy, obecnie nie przyjmujemy żadnych zastrzeżeń',
                    },
                    eta: {
                        delivery: `Szacowany czas dostawy wynosi około {{minutesToCustomer}} min`,
                        pickup: `Zamówienie będzie gotowe za około {{minutesToCustomer}} minut`,
                    },
                    start_button: 'Rozpocznij zamówienie',
                },
                history: {
                    invalid: 'Ponowne zamówienie nie jest możliwe, ponieważ część wcześniej zamówionych pozycji została zmieniona lub jest już niedostępna',
                },
                reorder: {
                    title: 'Szybkie pytanie na zamówienie',
                    description: 'Z zasady zamawiania produktów z czyszczenia',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Nie znaleziono zamówienia. Odśwież stronę i ponownie',
                    booking_not_found: 'Rezerwacja nie istnieje. Możliwe, że została usunięta',
                    generic: 'Coś poszło nie tak, aktualizacja karty lub powstała z nami',
                },
                connection: {
                    connected: 'Aktualizacje w czasie rzeczywistym',
                    connecting: 'Łączenie aktualizacji w czasie rzeczywistym',
                    disconnected: 'Odłączono w czasie rzeczywistym',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Ostrzeżenie',
                    title: 'Wyloguj się',
                    body: 'Wylogowanie i usunięcie wszystkich pozycji dodanych do koszyka',
                    cancel: 'Anulować',
                    proceed: 'Przystępować',
                },
                order_restart: {
                    warning: 'Ostrzeżenie',
                    title: 'Przejdź do szczegółów zamówienia',
                    body: 'Zmiana terminu dostawy, wydanie artykułów z koszyka, w którym niektóre elementy mogą być dostępne w zestawie',
                    cancel: 'Anulować',
                    proceed: 'Przystępować',
                },
                order_expired: {
                    subtitle: 'Ważny',
                    title: 'Zamówienie na termin natychmiast',
                    description: 'Wybrana godzina zamówienia jest już bardzo blisko. Dlatego termin realizacji zamówienia został zmieniony na natychmiast / jak najszybciej',
                    button: 'OK',
                },
                order_expiring: {
                    subtitle: 'Ważny',
                    title: 'Termin możliwy wkrótce upływa',
                    description: 'Twoje zamówienie musi pozostać przed {{time, timeFromTimestamp}}, w przeciwnym razie nie będzie już ważne',
                    button: 'OK',
                },
                location_permission: {
                    cancel: 'Anulować',
                    proceed: 'Przystępować',
                },
            },
            card_payment_authentication: {
                title: 'Uwierzytelnianie płatności',
                note: 'Nie zamykaj tego okna do potwierdzenia procesu w banku.',
            },
            maps: {
                cancel: 'Anulować',
                use_location: 'miejsce lokalizacji',
            },
            app_refresh: {
                refresh: 'Odświeżyć',
                title: 'Odśwież sklep',
                description: 'Nasz sklep został zaktualizowany. Odśwież przeglądarkę, aby uzyskać dostęp do najnowszej wersji. Po odświeżeniu może być konieczne ponowne otwarcie koszyka, aby przejść do finalizacji zamówienia.',
            },
        },
        sections: {
            nav_top: {
                guest: 'Gość',
                login: 'Zaloguj się',
                login_signup: 'Zaloguj się / Zarejestruj się',
                logout: 'Wyloguj się',
            },
            menus: {
                info: {
                    no_menus: 'Obecnie nie ma żadnych menu',
                    restrictions: 'Ograniczenia menu',
                    not_available: 'Menu opcjonalne',
                    unavailable: {
                        times: 'Menu opcjonalne, wymagania dotyczące zamówień nie dopuszczone do stosowania',
                        services: 'Menu opcjonalne, wymagania dotyczące zamówień nie dopuszczone do stosowania',
                        hours: 'Menu niedostępne, gdy zamówienia nie są dostępne w menu',
                        pre_order: 'Menu opcjonalne, Twoje zamówienie nie spełnia wymogów przedsprzedażowych',
                        age: 'Menu opcjonalne. Aby złożyć zamówienie z tego menu, należy się na koncie zweryfikowanym pod względem wagi',
                    },
                    services: {
                        title: 'Wymagania dotyczące zamówień',
                        pickup: 'Przetwórniki',
                        delivery: 'Dostawy',
                        dine_in: 'Na miejscu',
                    },
                    times: {
                        now: 'Brak działania w przedsprzedaży',
                        later: 'Tylko zamówienia w przedsprzedaży',
                    },
                    hours: {
                        title: 'Dostępna godzina',
                    },
                    preorder: {
                        title: 'Wymagania dotyczące zamówień w przedsprzedaży',
                        days_in_advance: 'Trzeba koniecznie {{days}} dni wcześniej',
                        cutoff_time: 'Ostateczny czas ostatniego dnia o {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Ograniczone wiekowo',
                        approved: 'Twoje konto zweryfikowane i możesz sprawdzić zamówienia z tego menu',
                        rejected: 'Aby złożyć zamówienie, wymagana jest weryfikacja wieku. Utwórz konto i prześlij swój identyfikator',
                    },
                },
                search: {
                    title: 'Przeglądaj menu',
                    no_result: 'Nic nie wróciło. Spróbować innego wyszukiwania hasła?',
                    placeholder: 'Czego Pan szuka?',
                },
            },
            category: {
                restrictions: 'Ograniczenia kategorii',
                not_available: 'Kategoria niedostępna',
                unavailable: {
                    services: 'Kategoria niedostępna, wymagania dotyczące zamówień nie dopuszczone do spożycia',
                    hours: 'Kategoria niedostępna, godzina Twoich zamówień nie mieści się w godzinach dostępnych w tej kategorii',
                },
            },
            info: {
                location: {
                    title: 'Lokalizacja',
                    view_map: 'Zobacz mapę',
                    phone: 'Telefon',
                },
                hours: {
                    title: 'Godziny otwarcia',
                    title_special: 'Specjalne otwarcie',
                },
                services: {
                    title: 'Usługi',
                    notes: 'Notatki',
                    delivery: {
                        ranges: 'Zakres dostawy',
                        zones: 'Strefy Dostaw',
                        view_zones: 'Wyświetlanie strefy na mapie',
                        fee: 'Opłata za dostawę',
                        fee_short: 'Opłata',
                        fee_varies: 'Różnie, pokazane w koszyku',
                        min_order: 'Minimalne zamówienie',
                        min_order_short: 'Min. zam.',
                        no_min_order: 'Brak obecnościgo zamówień',
                        free_amount: 'Kwota bezpłatnej dostawy',
                    },
                },
            },
            contact: {
                title: 'Skontaktuj się z nami',
                name: 'Nazwa',
                email: 'Adres e-mail',
                phone: 'Numer telefonu',
                message: 'Napisz swoją wiadomość...',
                send: 'Wyślij wiadomość',
                success: 'Twoja wiadomość została pomyślnie wysłana',
                error: 'Coś poszło nie tak. Najpierw ponownie lub później',
            },
            footer: {
                powered_by: 'Obsługiwane przez',
                terms_and_conditions: 'Regulamin',
                privacy: 'Polityka prywatności',
                cookie: 'Polityka plików cookie',
            },
        },
        pages: {
            payment_completed: {
                title: 'Twoja płatność została przetworzona. Dziękujemy za zamówienie!',
                subtitle: 'Informacje o zamówieniu zostały wysłane na Twój adres e-mail.',
                back_to_menu: 'Powrót do menu',
                close_tab: 'Zamknij tę kartę',
            },
            payment_failed: {
                title: 'Błąd podczas przetwarzania płatności.',
                subtitle: '',
                back_to_menu: 'Powrót do menu',
                close_tab: 'Zamknij tę kartę',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Potwierdzenie rezerwacji',
            details: {
                datetime: 'Rezerwacja dla',
                number_of_people: 'Liczba osób',
                placed: 'Umieszczony',
                updated: 'Ostatnia aktualizacja',
                notes: 'Notatki',
                name: 'Nazwa',
                email: 'E-mail',
                phone: 'Telefon',
                store_address: 'Adres sklepu',
            },
            status_update: {
                title: 'Rezerwacja {{number}} Zaktualizowano',
                body: 'Stan Twojej rezerwacji został zaktualizowany do {{status}}',
            },
            email_common: {
                name: 'Imię: {{name}}',
                phone: 'Telefon: {{number}}',
                number_of_people: 'Liczba osób: {{number}}',
                date: 'Dane: {{date}}',
                time: 'Czas: {{time}}',
                location: 'Lokalizacja sklepu: {{name}}',
                notes: 'Uwagi: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Nowa rezerwacja stolika {{number}} Zrób {{name}}',
                powered_by: 'Obsługiwane przez {{name}}',
                overview: 'Nowa prośba o rezerwację stolika',
                title: 'Nowa rezerwacja dla {{name}}',
                subtitle: 'Numer rezerwacji {{number}}',
                description_confirmed: 'Rezerwacja została automatycznie potwierdzona. Możesz ją anulować w panelu administracyjnym, a klient otrzyma powiadomienie e-mailem',
                description_unconfirmed: 'Potwierdź lub anuluj rezerwację za pośrednictwem panelu a potwierdzenie',
                url_pre_text: 'Zobacz i zaktualizuj na',
            },
            email_new_booking_customer: {
                subject: 'Prośba o rezerwację stolika',
                powered_by: 'Obsługiwane przez {{name}}',
                overview: 'Nowa prośba o rezerwację stolika',
                title: 'Dziękujemy za rezerwację',
                subtitle: 'Numer rezerwacji {{number}}',
                description: '<b>Otrzymasz kolejny e-mail, gdy Twoja rezerwacja zostanie potwierdzona lub odrzucona.</b><br>Skontaktuj się z nami, jeśli chcesz wprowadzić zmiany w rezerwacji. Szczegóły rezerwacji:',
                url_pre_text: 'Potwierdzenie rezerwacji sprawdź w czasie rzeczywistym pod adresem',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Rezerwacja stolika potwierdzona',
                subject_unconfirmed: 'Rezerwacja stolika anulowana',
                powered_by: 'Obsługiwane przez {{name}}',
                overview: 'Prośba o rezerwację stolika',
                title_confirmed: 'Rezerwacja potwierdzona',
                title_unconfirmed: 'Rezerwacja anulowana',
                subtitle: 'Numer rezerwacji {{number}}',
                description_confirmed: 'Cieszymy się na spotkanie z Tobą. Skontaktuj się z nami, aby poprosić o zmiany w rezerwacji',
                description_unconfirmed: 'Z przykrością informujemy, że Twoja prośba o rezerwację nie mogła zostać zaakceptowana. Przepraszamy za wszelkie niedogodności. Skontaktuj się z nami, jeśli masz pytania',
                url_pre_text: 'Potwierdzenie rezerwacji sprawdź w czasie rzeczywistym pod adresem',
            },
            email_status_update_customer: {
                subject: 'Rezerwacja #{{number}} – {{subjectLabel}}',
                body: 'Twoja rezerwacja #{{number}} w {{store}} ma teraz status {{status}}.',
            },
            errors: {},
            status_warning: 'Zaktualizuj status tej rezerwacji w panelu administracyjnym na stronie rezerwacji',
        },
    },
    email_delayed_order: {
        subject: 'Zamówienie #{{number}} – {{subjectLabel}}',
        header: 'Zaktualizowany czas przygotowania',
        title: 'Zaktualizowany czas przygotowania',
        order_number: 'Numer zamówienia: {{number}}',
        description: 'Twoje zamówienie będzie gotowe o {{time}}.',
        order_time_updated_to: 'Czas Twojego zamówienia został zaktualizowany.',
        powered_by: 'Obsługiwane przez {{name}}',
        button_text: 'Śledź zamówienie',
        subject_label: 'Zaktualizowany czas przygotowania',
        subject_label_delivery: 'Zaktualizowany czas dostawy',
        body_ready: 'Twoje zamówienie będzie gotowe o {{time}}.',
        body_delivery: 'Twoje zamówienie zostanie dostarczone o {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Szac. Gotowy czas',
            est_driver_pickup_time: 'Szac. Czas odbioru prywatnego',
            est_delivery_time: 'Szac. Czas dostawy',
            tab_details: 'Bliższe dane',
            tab_dishes: 'Rzeczy',
            future_order: 'Przyszły porządek',
            reprint: 'PONOWNY WYDRUK',
            details: {
                order_no: 'Nr zamówienia',
                status: 'Stana',
                placed: 'Umieszczony',
                due: 'niezależny',
                due_asap: 'Teraz / JAK NAJSZYBCIEJ',
                last_updated: 'Ostatnia aktualizacja',
                total: 'Całkowity',
                type: 'Typ',
                origin: 'Pochodzenie',
                table: 'Tabela',
                number_of_people: 'Liczba Osób',
                payment_method: 'Metoda płatności',
                payment_status: 'Stan płatności',
                payment_currency: 'Waluta płatności',
                notes: 'Notatki',
                name: 'Nazwa',
                email: 'E-mail',
                phone: 'Telefon',
                distance: 'Dystans',
                driving_time: 'Czas jazdy',
                delivery_zone: 'Strefa',
                delivery_address: 'Adres dostawy',
                delivery_provider: 'Dostępność dostawy',
                delivery_tracking: 'Śledzenie dostawy',
                delivery_return_tracking: 'Śledź powrót',
                delivery_tracking_link: 'Śledź zamówienie',
                tookan_status: 'Stan Tookany',
                tookan_status_failed_book: 'Nie udało się dotrzeć do dostawy',
                tookan_status_failed_update: 'Nie udało się zgłosić rezerwacji',
                tookan_status_success: 'Zarezerwowane do dostawy',
                store_address: 'Adres sklepu',
                destination: 'Miejsce docelowe',
                estimated_arrival_time: 'Oszacuj czas przybycia',
                delivery_status: 'Stan dostawy',
                delivery_track_your_order: 'Śledź swoje zamówienie',
                delivery_text: 'Dostawa',
                arrival_date: 'Dane przychodzące',
            },
            dishes: {
                headings: {
                    quantity: 'Ilość',
                    item: 'Przedmiot',
                    price: 'Cena',
                },
                notes: 'Notatki',
                remove_ingredients: 'Usuń pozostał',
            },
            status_update: {
                title: 'Zamówienie {{number}} Zaktualizowano',
                body: 'Stan Twojego zamówienia został zaktualizowany do {{status}}',
            },
            wait_time_update: {
                title: 'Zamówienie {{number}} Zaktualizowano',
                body: 'Termin realizacji zamówienia został zaktualizowany',
            },
            delivery_update: {
                title: 'Zamówienie {{number}} Zaktualizowano',
                body: 'Twoje zamówienie zostało wysłane do dostawy. Zobacz link do wniosku w czasie rzeczywistym',
            },
            payment_status_update: {
                title: 'Zamówienie {{number}} Zaktualizowano',
                body: 'Status płatności za Twoje zamówienie zostało zaktualizowane.',
            },
            email_new_order_restaurant: {
                subject: 'Nowe zamówienie ({{number}}) - {{name}}',
                powered_by: 'Obsługiwane przez {{name}}',
                overview: 'Powiadomienie o nowym zamówieniu',
                title: 'Nowe zamówienie złożone o {{name}}',
                subtitle: 'Numer zamówienia {{number}}',
                description: 'Szczegóły i szczegóły w panelu administracyjnym',
                button_text: 'Śledź zamówienie',
                track_delivery_button_text: 'Śledź dostawę',
            },
            email_new_order_customer: {
                subject: 'Potwierdzenie zamówień ({{number}})',
                powered_by: 'Obsługiwane przez {{name}}',
                overview: 'Powiadomienie o nowym zamówieniu',
                title: 'Nowe zamówienie złożone o {{name}}',
                subtitle: 'Numer zamówienia {{number}}',
                description: 'Przeglądaj szczegółowe informacje na swoim koncie online w czasie dostępu',
                button_text: 'Śledź zamówienie',
                track_delivery_button_text: 'Śledź dostawę',
            },
            email_order_completed_by_customer: {
                subject: 'Zamówienie ({{number}}) zrealizowane przez Klienta',
                powered_by: 'Obsługiwane przez {{name}}',
                overview: 'Powiadomienie o realizacji zamówień',
                title: 'Zamówienie zrealizowane o {{name}}',
                subtitle: 'Numer zamówienia {{number}}',
                description: 'Przeglądaj szczegóły i aktualizuj swoje zamówienie za pośrednictwem interfejsu nawigacyjnego lub wejścia z paragonu pod adresem',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) z o.o. w cenie',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Opłata za dostawę',
            delivery_fee_offset: 'Zniżka na opłatę za dostawę',
            delivery_fee_total: 'Całkowita opłata za dostawę',
            promo: 'Rabat: {{name}} ({{value, currency}} + {{percent}}%)',
            promo_percent: 'Rabat: {{name}} ({{percent}}%)',
            promo_fixed: 'Rabat: {{name}}',
            promo_none: 'Rabat: {{name}}',
            cart: 'Wózek',
            tip: 'Zamów wskazówkę',
            total: 'Całkowity',
        },
        status: {
            unconfirmed: 'Niepotwierdzone',
            awaiting_payment: 'Oczekiwanie na płatność',
            confirmed: 'Potwierdzony',
            ready: 'Gotowy',
            on_route: 'Na trasie',
            complete: 'Kompletny',
            cancelled: 'Odwołany',
            seated: 'Usadzony',
        },
        searching: {
            lalamove_search_placeholder: 'Wyszukaj według zamówienia identyfikatora dostawy Lalamove',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Nie płynny',
                },
            },
            dish: {
                no_stock: 'Brak w magazynie',
                not_available: 'Niedostępne',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'Kod utrzymujący e-mail',
            register_confirmation_code_email: 'Twój kod użytkowy wyślij e-mail na adres {{confirmation_code}} (wygasa za 24 godziny)',
            register_confirmation_code_email_onbehalf: 'Twój kod potwierdzający e-mail to {{confirmation_code}} (wygasa za 24 godziny). Ten kod dotyczy adresu e-mail {{email}}.',
        },
    },
};
//# sourceMappingURL=pl.js.map